import { IAppState } from '../../redux';
import { selectServiceById } from './selectServiceById';
import { EUnavailableReason, EServiceId } from '../../redux/reducers';

const TOP_UNAVAILABLE_REASON_TYPES = [EUnavailableReason.top3ServiceDenied, EUnavailableReason.onlyInAction];

export function selectIsTopServiceUnavailable(state: IAppState): boolean {
  const service = selectServiceById(EServiceId.top, state);

  if (!service || !service.unavailableReasonType) {
    return false;
  }

  return TOP_UNAVAILABLE_REASON_TYPES.includes(service.unavailableReasonType);
}
